angular.module('um.categories').config(['$stateProvider', function($stateProvider) {
    'use strict';

    $stateProvider
        .state('main.categories', {
            'abstract': true,
            url: 'categories/',
            template: '<ui-view/>',
            breadcrumb: 'CATEGORY_CATEGORIES'
        })
        .state('main.categories.overview', {
            url: 'overview',
            templateUrl: 'modules/categories/categories.overview.html',
            controller: 'categories.overview.controller',
            controllerAs: 'categories',
            breadcrumb: 'OVERVIEW'
        })
        .state('main.categories.create', {
            url: 'create',
            templateUrl: 'modules/categories/categories.html',
            controller: 'categories.controller',
            controllerAs: 'category',
            breadcrumb: 'CREATE'
        })
        .state('main.categories.edit', {
            url: 'edit/:categoryId',
            templateUrl: 'modules/categories/categories.html',
            controller: 'categories.controller',
            controllerAs: 'category',
            breadcrumb: 'EDIT'
        });
}]);
